import React from "react";
import BackButton from "../components/BackButton";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-amber-100 p-6">
      <BackButton className="mb-6" />
      <div className="min-h-screen flex items-center justify-center bg-yellow-50">
        <div className="text-center p-8">
          <div className="text-4xl">📬 Contact Us Page Coming Soon!</div>
          <div className="mt-2 text-sm text-gray-600">
            Reach out to us at <span className="underline">team@artmosphere.com</span>
          </div>
        </div>
      </div>
    </div>
  );
}
